// extracted by mini-css-extract-plugin
export default {"page":"Student_page__HgYmV"};